module.exports = __webpack_public_path__ + "img/p001.318c402f.png";